 import './IndexComponent.css';
 import HeaderComponent from "./HeaderComponent";
 import FooterCompnent from './FooterCompnent';
 import { BrowserRouter } from 'react-router-dom';
 


 export default function IndexComponent(){

    return(
        <>
            <BrowserRouter>
                <HeaderComponent />
                <FooterCompnent />
            </BrowserRouter>
            
        </>
    )
 }